module.exports = __webpack_public_path__ + "img/adpoints-logo-w.c7d0d3e6.png";